export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14874.5c808ca7.jpg";